/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ClassificationsControllerFindOneQueryResponse, ClassificationsControllerFindOnePathParams, ClassificationsControllerFindOneQueryParams, ClassificationsControllerFindOne400, ClassificationsControllerFindOne401, ClassificationsControllerFindOne403, ClassificationsControllerFindOne404 } from "../../models/documentClassificationsController/ClassificationsControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { classificationsControllerFindOne } from "../../clients/document-classificationsService/classificationsControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const classificationsControllerFindOneQueryKey = (documentId: ClassificationsControllerFindOnePathParams["documentId"], renditionId: ClassificationsControllerFindOnePathParams["renditionId"], classificationId: ClassificationsControllerFindOnePathParams["classificationId"], params: ClassificationsControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/documents/:documentId/renditions/:renditionId/classifications/:classificationId',
  params: {
    documentId: documentId,
    renditionId: renditionId,
    classificationId: classificationId
  }
}, ...(params ? [params] : [])] as const;
export type ClassificationsControllerFindOneQueryKey = ReturnType<typeof classificationsControllerFindOneQueryKey>;
export function classificationsControllerFindOneQueryOptions(documentId: ClassificationsControllerFindOnePathParams["documentId"], renditionId: ClassificationsControllerFindOnePathParams["renditionId"], classificationId: ClassificationsControllerFindOnePathParams["classificationId"], params?: ClassificationsControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = classificationsControllerFindOneQueryKey(documentId, renditionId, classificationId, params);
  return queryOptions<ClassificationsControllerFindOneQueryResponse, ResponseErrorConfig<ClassificationsControllerFindOne400 | ClassificationsControllerFindOne401 | ClassificationsControllerFindOne403 | ClassificationsControllerFindOne404>, ClassificationsControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!(documentId && renditionId && classificationId),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return classificationsControllerFindOne(documentId, renditionId, classificationId, params, config);
    }
  });
}

/**
 * @description Returns detailed information about a specific classification. Use ?include=results to include classification results.
 * @summary Get a specific classification
 * {@link /api/v1/documents/:documentId/renditions/:renditionId/classifications/:classificationId}
 */
export function useClassificationsControllerFindOne<TData = ClassificationsControllerFindOneQueryResponse, TQueryData = ClassificationsControllerFindOneQueryResponse, TQueryKey extends QueryKey = ClassificationsControllerFindOneQueryKey>(documentId: ClassificationsControllerFindOnePathParams["documentId"], renditionId: ClassificationsControllerFindOnePathParams["renditionId"], classificationId: ClassificationsControllerFindOnePathParams["classificationId"], params?: ClassificationsControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<ClassificationsControllerFindOneQueryResponse, ResponseErrorConfig<ClassificationsControllerFindOne400 | ClassificationsControllerFindOne401 | ClassificationsControllerFindOne403 | ClassificationsControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? classificationsControllerFindOneQueryKey(documentId, renditionId, classificationId, params);
  const query = useQuery({
    ...classificationsControllerFindOneQueryOptions(documentId, renditionId, classificationId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ClassificationsControllerFindOne400 | ClassificationsControllerFindOne401 | ClassificationsControllerFindOne403 | ClassificationsControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}